const NETWORK_ERROR_CODES: readonly string[] = [
  'ECONNABORTED',
  'ECONNREFUSED',
  'ECONNRESET',
  'ENOTFOUND',
  'ETIMEDOUT',
  'EHOSTUNREACH',
  'ERR_NETWORK',
];

export function isNetworkErrorCode(code: string | undefined): boolean {
  return code !== undefined && NETWORK_ERROR_CODES.includes(code);
}
